<p-toast />
<p-confirmpopup />

@for (stock of stocks; track stock) {
  <div style="margin-bottom: 5px; font-size: 90%">
    <p-tag
      severity="success"
      value="{{ stock.areaName }}"></p-tag>
    <p-tag
      severity="contrast"
      value="{{ getStoreName(stock.storeCode, stock.storeName) }}"></p-tag>
    @if (stock.price) {
      <p-tag
        [style]="{ background: '#FF8C00', color: 'white' }"
        value="¥{{ stock.price.toLocaleString() }}"></p-tag>
    }
    <p-tag
      [style]="getStyle(stock.hasStock)"
      [class]="getClass(stock)"
      value="{{ stock.stockNum }}"></p-tag>
    @if (!stock.isPurchased) {
      <p-tag
        class="clickable"
        [style]="offStyle"
        value="購入"
        (click)="confirm($event, stock)"></p-tag>
    }
    @if (stock.isPurchased) {
      <p-tag
        class="clickable"
        icon="pi pi-check"
        [style]="onStyle"
        value="購入:{{ stock.purchasedUserName }}{{ quantityLabel(stock) }}({{ stock.purchasedAt | date: 'MMdd' }})"
        (click)="confirmCancel($event, stock)"></p-tag>
    }
    @if (!stock.isDisplay) {
      <p-tag
        class="clickable"
        [style]="offStyle"
        value="展示"
        (click)="confirmDisplay($event, stock)"></p-tag>
    }
    @if (stock.isDisplay) {
      <p-tag
        class="clickable"
        icon="pi pi-check"
        [style]="onStyle"
        value="展示:{{ stock.displayUserName }}({{ stock.displaySetAt | date: 'MMdd' }})"
        (click)="confirmDisplayCancel($event, stock)"></p-tag>
    }
    <!-- 店頭無（データ上は isNotFound）badge for all stocks -->
    @if (!stock.isNotFound) {
      <p-tag
        class="clickable"
        [style]="offStyle"
        value="店頭無"
        (click)="confirmNotFound($event, stock)"></p-tag>
    }
    @if (stock.isNotFound) {
      <p-tag
        class="clickable"
        icon="pi pi-check"
        [style]="onStyle"
        value="店頭無:{{ stock.notFoundUserName }}({{ stock.notFoundAt | date: 'MMdd' }})"
        (click)="confirmFound($event, stock)"></p-tag>
    }
    <!-- 規制・見送・店員無（6 段階のボタンの残り 3 つ）。付いていれば 名前(日付) 付きで出す -->
    @for (b of flagButtons; track b) {
      @if (!isFlagOn(stock, b)) {
        <p-tag
          class="clickable"
          [style]="offStyle"
          [value]="b.label"
          [pTooltip]="b.description"
          tooltipPosition="top"
          (click)="confirmFlag($event, stock, b)"></p-tag>
      }
      @if (isFlagOn(stock, b)) {
        <p-tag
          class="clickable"
          icon="pi pi-check"
          [style]="onStyle"
          value="{{ b.label }}:{{ flagUserName(stock, b) }}({{ flagAt(stock, b) | date: 'MMdd' }})"
          [pTooltip]="b.description"
          tooltipPosition="top"
          (click)="confirmFlag($event, stock, b)"></p-tag>
      }
    }
    <!-- 確認済 badge only for Donki stocks -->
    @if (stock.type === 'donki') {
      @if (!stock.isConfirmed) {
        <p-tag
          class="clickable"
          [style]="offStyle"
          value="確認済にする"
          (click)="confirmDonki($event, stock)"></p-tag>
      }
      @if (stock.isConfirmed) {
        <p-tag
          class="clickable"
          icon="pi pi-check"
          [style]="onStyle"
          value="確認済:{{ stock.confirmedUserName }}({{ stock.confirmedAt | date: 'MMdd' }})"
          (click)="confirmCancelDonki($event, stock)"></p-tag>
      }
    }
    <!-- メモがある店舗は、鉛筆と (i) を赤にして一目で分かるようにする（2026-10-17 ユーザー指定） -->
    <i
      class="pi pi-user-edit clickable"
      [class.has-memo]="!!stock.memo"
      style="font-size: 1rem; margin-left: 5px"
      (click)="openMemo(stock)"></i>
    @if (!!stock.memo) {
      <i
        class="pi pi-info-circle has-memo"
        style="margin-left: 5px"
        [pTooltip]="tooltipContent"></i>
    }
    <ng-template #tooltipContent>
      <div>{{ stock.memoUserName }}({{ stock.memoAddedAt | date: 'MMdd' }})</div>
      <div>{{ stock.memo }}</div>
    </ng-template>
  </div>
}

<!-- 購入の個数入力（2026-10-17 ユーザー指定）。初期値 1。1 個ならそのまま「購入」を押す。上限はその店の在庫数 -->
<p-dialog
  header="購入しましたか？"
  [(visible)]="showPurchase"
  [modal]="true"
  [style]="{ width: '24rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  [draggable]="false"
  [resizable]="false">
  <div class="flex flex-wrap align-items-center gap-2">
    <label for="purchaseQuantity">個数</label>
    <!-- [max] は付けない: 付けると欄を離れた時に在庫数へ黙って丸められ、15 と打っても 7 個で登録されてしまう。
    代わりに打った値をその場で受け取り、在庫より多ければ注意を出して「購入」を押せなくする -->
    <p-inputnumber
      inputId="purchaseQuantity"
      [(ngModel)]="purchaseQuantity"
      (onInput)="purchaseQuantity = $event.value"
      [min]="1"
      [showButtons]="true"
      [inputStyle]="{ width: '5rem' }"></p-inputnumber>
    <span class="white-space-nowrap text-color-secondary">/ 在庫 {{ purchaseMax }}</span>
    <p-button
      label="購入"
      [disabled]="!isQuantityValid()"
      (onClick)="doPurchase()"></p-button>
  </div>
  @if (!isQuantityValid()) {
    <small class="p-error block mt-2">在庫数（{{ purchaseMax }}）より多くは入れられません</small>
  }
</p-dialog>

<p-dialog
  header="メモを登録"
  [(visible)]="showMemo"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <div class="grid">
    <div class="col-10">
      <textarea
        rows="4"
        class="p-inputtext"
        style="width: 100%"
        pTextarea
        [(ngModel)]="memoModel.memo"
        placeholder="メモを入力"></textarea>
    </div>
    <div class="col-2">
      <p-button
        label="登録"
        [disabled]="!memoModel.memo"
        (onClick)="doRegisterMemo()"></p-button>
    </div>
  </div>
</p-dialog>
